function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#373B3F;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:12;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#1CC29F;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#52595F;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#ACE4D6;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  transform: "translate(-37.000000, -83.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(43.000000, 89.000000)"
}, React.createElement("g", {
  id: "sw-wide",
  transform: "translate(129.000000, 18.000300)"
}, React.createElement("g", {
  id: "assets_x2F_wordmark_x2F_primary"
}, React.createElement("g", {
  id: "Group-16"
}, React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M11.7,73C6.8,71.6,2.9,69.7,0,67.5L5.2,56c2.8,2.1,6.2,3.7,10,5 c3.9,1.3,7.8,1.9,11.6,1.9c4.3,0,7.5-0.6,9.6-1.9c2.1-1.3,3.1-3,3.1-5.1c0-1.6-0.6-2.9-1.8-3.9c-1.2-1-2.8-1.9-4.7-2.5 c-1.9-0.6-4.5-1.3-7.7-2.1c-5-1.2-9.1-2.4-12.3-3.6c-3.2-1.2-5.9-3.1-8.2-5.7c-2.3-2.6-3.4-6.1-3.4-10.5c0-3.8,1-7.3,3.1-10.4 c2.1-3.1,5.2-5.6,9.3-7.4C17.9,8,23,7,29,7c4.2,0,8.3,0.5,12.3,1.5s7.5,2.4,10.5,4.3l-4.7,11.6C41,21,35,19.3,28.9,19.3 c-4.3,0-7.4,0.7-9.4,2.1c-2,1.4-3,3.2-3,5.5s1.2,3.9,3.5,5c2.3,1.1,5.9,2.2,10.7,3.2c5,1.2,9.1,2.4,12.3,3.6 c3.2,1.2,5.9,3.1,8.2,5.6c2.3,2.6,3.4,6,3.4,10.4c0,3.8-1,7.2-3.1,10.3c-2.1,3.1-5.2,5.6-9.4,7.4c-4.2,1.8-9.3,2.7-15.3,2.7 C21.6,75.1,16.5,74.4,11.7,73z M99.2,58.9c2.4-2.5,3.6-5.9,3.6-10.2c0-4.3-1.2-7.7-3.6-10.2c-2.4-2.5-5.5-3.8-9.2-3.8 c-3.8,0-6.8,1.3-9.2,3.8c-2.4,2.5-3.6,5.9-3.6,10.2c0,4.3,1.2,7.7,3.6,10.2c2.4,2.5,5.5,3.8,9.2,3.8 C93.7,62.7,96.8,61.4,99.2,58.9z M105.3,25.9c3.8,2.2,6.9,5.2,9.1,9.1c2.2,3.9,3.3,8.5,3.3,13.7c0,5.2-1.1,9.8-3.3,13.7 c-2.2,3.9-5.2,7-9.1,9.1c-3.8,2.2-8.1,3.2-12.8,3.2c-6.4,0-11.5-2-15.2-6.1v23.6H62.7V23.4h14v5.8c3.6-4.4,8.9-6.6,15.9-6.6 C97.2,22.7,101.5,23.7,105.3,25.9z M127.4,74V4.2h14.6V74H127.4z M155.7,74V23.4h14.6V74H155.7z M156.4,14 c-1.7-1.6-2.5-3.5-2.5-5.8c0-2.3,0.8-4.3,2.5-5.8c1.7-1.6,3.9-2.4,6.6-2.4c2.7,0,4.9,0.8,6.6,2.3c1.7,1.5,2.5,3.4,2.5,5.6 c0,2.4-0.8,4.5-2.5,6.1c-1.7,1.6-3.9,2.4-6.6,2.4C160.3,16.4,158.1,15.6,156.4,14z M216.5,71.5c-1.4,1.1-3.2,1.9-5.3,2.4 c-2.1,0.5-4.3,0.8-6.6,0.8c-6,0-10.6-1.5-13.9-4.6c-3.3-3.1-4.9-7.6-4.9-13.5V34.7h-7.8V23.4h7.8V12.2h14.6v11.2h12.6v11.3 h-12.6v21.7c0,2.1,0.5,3.8,1.6,4.9c1.1,1.2,2.6,1.7,4.6,1.7c2.3,0,4.3-0.6,5.9-1.9L216.5,71.5z M306.3,23.4L288,74H274 l-11.4-31.4L250.9,74h-14.1l-18.2-50.6h13.8l11.9,34.2l12.4-34.2h12.4l12,34.2l12.3-34.2H306.3z M313.2,74V23.4h14.6V74H313.2z  M313.9,14c-1.7-1.6-2.5-3.5-2.5-5.8c0-2.3,0.8-4.3,2.5-5.8c1.7-1.6,3.9-2.4,6.6-2.4c2.7,0,4.9,0.8,6.6,2.3 c1.7,1.5,2.5,3.4,2.5,5.6c0,2.4-0.8,4.5-2.5,6.1c-1.7,1.6-3.9,2.4-6.6,2.4C317.8,16.4,315.6,15.6,313.9,14z M346.1,73.2 c-4-1-7.2-2.3-9.6-3.9l4.9-10.5c2.3,1.4,5,2.6,8.2,3.5c3.2,0.9,6.3,1.4,9.4,1.4c6.2,0,9.3-1.5,9.3-4.6c0-1.4-0.8-2.5-2.5-3.1 c-1.7-0.6-4.3-1.2-7.8-1.6c-4.1-0.6-7.5-1.3-10.2-2.2c-2.7-0.8-5-2.3-7-4.3s-3-5-3-8.8c0-3.2,0.9-6,2.8-8.5 c1.8-2.5,4.5-4.4,8.1-5.8c3.5-1.4,7.7-2.1,12.5-2.1c3.6,0,7.1,0.4,10.7,1.2c3.5,0.8,6.5,1.9,8.8,3.2l-4.9,10.4 c-4.4-2.5-9.3-3.8-14.5-3.8c-3.1,0-5.5,0.4-7,1.3c-1.6,0.9-2.3,2-2.3,3.4c0,1.6,0.8,2.7,2.5,3.3c1.7,0.6,4.4,1.2,8.1,1.8 c4.1,0.7,7.5,1.4,10.1,2.2c2.6,0.8,4.9,2.2,6.8,4.3c1.9,2.1,2.9,5,2.9,8.6c0,3.1-0.9,5.9-2.8,8.4c-1.9,2.4-4.6,4.3-8.2,5.7 c-3.6,1.3-7.9,2-12.8,2C354.2,74.7,350.1,74.2,346.1,73.2z M406.2,36.6c-2.3,1.9-3.6,4.5-4.1,7.7h24.9 c-0.5-3.2-1.9-5.7-4.1-7.7c-2.3-1.9-5-2.9-8.3-2.9C411.2,33.7,408.4,34.7,406.2,36.6z M440.4,52.8h-38.2 c0.7,3.1,2.3,5.6,4.9,7.4c2.6,1.8,5.8,2.7,9.6,2.7c2.6,0,5-0.4,7-1.2s3.9-2,5.7-3.7l7.8,8.5c-4.8,5.5-11.7,8.2-20.8,8.2 c-5.7,0-10.7-1.1-15.1-3.3c-4.4-2.2-7.8-5.3-10.1-9.3c-2.4-3.9-3.6-8.4-3.6-13.4c0-4.9,1.2-9.4,3.5-13.4s5.6-7.1,9.7-9.3 c4.1-2.2,8.7-3.3,13.7-3.3c4.9,0,9.4,1.1,13.4,3.2c4,2.1,7.1,5.2,9.4,9.2c2.3,4,3.4,8.6,3.4,13.9 C440.7,49.1,440.6,50.4,440.4,52.8z"
})))), React.createElement("g", {
  id: "Group-2"
}, React.createElement("polygon", {
  id: "stroke",
  className: "st1",
  points: "0.7,25.7 44.3,0.5 87.8,25.7 87.8,93.3 0.7,93.3  "
}), React.createElement("polygon", {
  id: "bg",
  className: "st2",
  points: "0.7,26.2 44.3,1 87.8,26.2 87.8,93.8 0.7,93.8  "
}), React.createElement("g", {
  id: "assets_x2F_logo_x2F_primary"
}, React.createElement("path", {
  id: "Fill-1",
  className: "st3",
  d: "M33.4,57.5L44,51.4L0,26v25.1c3.3-1.8,7.5-2.7,12.2-2.7C22.6,48.4,29.1,52.8,33.4,57.5"
}), React.createElement("path", {
  id: "Fill-4",
  className: "st3",
  d: "M14,92.5c4.4,0,7.7-1.3,7.7-4.6c0-3.4-4.3-4.7-9.5-6c-3.9-1-8.4-2-12.2-3.9v6.4 C3.2,89.6,8.5,92.5,14,92.5"
}), React.createElement("polygon", {
  id: "Fill-6",
  className: "st4",
  points: "88,76.8 88,26 44,51.4  "
}), React.createElement("polygon", {
  id: "Fill-9",
  className: "st5",
  points: "88,26 44,0.6 0,26 44,51.4  "
}), React.createElement("path", {
  id: "Fill-12",
  className: "st0",
  d: "M44,51.4l-10.6,6.1l-11.3,6.5c-2.9-2.3-6.6-4-10-4c-4.1,0-6.2,1.4-6.2,3.9 c0,2.9,2.9,4.3,6.8,5.4c0.8,0.2,1.7,0.5,2.6,0.7c8.7,2.1,20.4,4.8,20.4,16.8c0,2.5-0.5,5-1.7,7.3H88V76.8L44,51.4z"
}), React.createElement("path", {
  id: "Fill-14",
  className: "st1",
  d: "M15.4,70.1c-0.9-0.2-1.8-0.5-2.6-0.7c-4-1.1-6.8-2.5-6.8-5.4c0-2.5,2.1-3.9,6.2-3.9 c3.4,0,7.1,1.7,10,4l11.3-6.5c-4.3-4.7-10.9-9.1-21.2-9.1c-4.8,0-8.9,0.9-12.2,2.7v25.7V78c3.8,1.9,8.3,2.9,12.2,3.9 c5.3,1.3,9.5,2.6,9.5,6c0,3.3-3.3,4.6-7.7,4.6c-5.6,0-10.8-3-14-8.1v9.8h34.1c1.2-2.3,1.7-4.8,1.7-7.3 C35.8,74.9,24.1,72.2,15.4,70.1"
})))));

var SvgSplitwiseLogoDark = function SvgSplitwiseLogoDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 117",
    style: {
      enableBackground: "new 0 0 576 117"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSplitwiseLogoDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splitwise_logo_dark.36348057.svg";
export { ForwardRef as ReactComponent };